import {SimplePage} from "../../elements/Pages";
import React from "react";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import ListViewTable from "../../elements/tables/ListViewTable";
import {getBooks, startAssignBookCodes} from "../../../api/books";
import {toast} from "react-toastify";
import {ClockIcon} from "@heroicons/react/20/solid";


const columns = [
    {
        accessorKey: 'title',
        id: 'title',
        header: 'Titel',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'publisher.name',
        id: 'publisher',
        header: 'Verlag',
        enableColumnFilter: true,
    },
    {
        accessorKey: 'order_number',
        id: 'order_number',
        header: 'Bestellnr.',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'is_digital',
        id: 'is_digital',
        header: 'Digital',
        columnType: 'yesno',
        yesLabel: 'Digital',
        noLabel: 'Druck',
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
    },
    {
        id: 'code_summary',
        header: 'Codes (frei | fehlend)',
        cell: ({row, value}) => (
            <>
            {row.original.is_digital && <span>{row.original.available_codes} | <span className={row.original.missing_code_count > 0 ? "text-red-700" : "text-green-600"}>{row.original.missing_code_count}</span>
                </span>}
                </>
        ),
        enableColumnFilter: false,
        headerClassNames: "narrow-filter",
    },
    {
        accessorKey: 'courses',
        id: 'courses',
        header: 'Kurse',
        columnType: 'm2m',
        labelAttr: 'course_number',
        enableColumnFilter: true,
        filterFn: "containsString",
    },
    {
        accessorKey: 'school_subjects',
        id: 'school_subjects',
        header: 'Fächer',
        columnType: 'm2m',
        labelAttr: 'name',
        enableColumnFilter: true,
        filterFn: "containsString",
    },
];

export default function BookList() {

    const queryClient = useQueryClient()

    const {isLoading, isSuccess, data: rawData, refetch} = useQuery(
        ['books'],
        () => getBooks()
    );

    // Transform data to add school_subjects field for filtering
    const data = rawData?.map(book => {
        if (!book.courses || !Array.isArray(book.courses)) {
            return {...book, school_subjects: []};
        }

        const subjects = book.courses
            .filter(course => course.school_subject)
            .map(course => course.school_subject);

        // Create array of unique subjects as objects for m2m handling
        const uniqueSubjects = [...new Set(subjects)];
        const subjectObjects = uniqueSubjects.map(subject => ({name: subject}));

        return {...book, school_subjects: subjectObjects};
    });

    function getRowLink(row) {
        return `/books/${row.original.id}`;
    }

    async function handleStart() {
        try {
            await startAssignBookCodes()
            toast.success("Codevergabe gestartet.")
            // queryClient.invalidateQueries({ queryKey: ['book_code_assignment_summary'] })
        } catch (e) {
            toast.error("Es ist ein Fehler aufgetreten")
        }
    }

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">
                            Bücher
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <button onClick={handleStart}
                                type="button"
                                className="cursor-pointer inline-flex items-center justify-center px-4 py-2
                           border border-gray-300 shadow-sm text-sm font-medium rounded-md
                           text-gray-700 bg-white hover:bg-gray-50 focus:outline-none
                           focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100
                           focus:ring-blue-500"
                        >Codevergabe starten <ClockIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true"/>
                        </button>

                        <button onClick={refetch}
                                type="button"
                                className="cursor-pointer inline-flex items-center justify-center px-4 py-2
                           border border-gray-300 shadow-sm text-sm font-medium rounded-md
                           text-gray-700 bg-white hover:bg-gray-50 focus:outline-none
                           focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100
                           focus:ring-blue-500"
                        >Aktualisieren
                        </button>
                    </div>
                </div>

                {/* Summary Section */}
                {/*{summary && (*/}
                {/*    <div className="mt-6 mb-6 ">*/}
                {/*        <div className="bg-yellow-50 shadow sm:rounded-lg">*/}
                {/*            <div className="px-4 py-5 sm:p-6">*/}
                {/*                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">*/}
                {/*                    Zusammenfassung Codevergabe*/}
                {/*                </h3>*/}

                {/*                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">*/}
                {/*                    /!* Missing codes per book *!/*/}
                {/*                    {summary.missing_per_book && summary.missing_per_book.length > 0 && (*/}
                {/*                        <div>*/}
                {/*                            <h4 className="text-md font-medium text-gray-900 mb-3">*/}
                {/*                                Bücher mit fehlenden Codes*/}
                {/*                            </h4>*/}
                {/*                            <div className="space-y-2">*/}
                {/*                                {summary.missing_per_book.map((book) => (*/}
                {/*                                    <div key={book.id} className="flex justify-between items-center p-3 bg-gray-50 rounded-md">*/}
                {/*                                        <Link*/}
                {/*                                            to={`/books/${book.id}`}*/}
                {/*                                            className="text-sm font-medium text-imsblue-600 hover:text-imsblue-900"*/}
                {/*                                        >*/}
                {/*                                            {book.title}*/}
                {/*                                        </Link>*/}
                {/*                                        <span className="text-sm text-red-600 font-medium">*/}
                {/*                                            {book.missing} fehlen*/}
                {/*                                        </span>*/}
                {/*                                    </div>*/}
                {/*                                ))}*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    )}*/}

                {/*                    /!* Students missing codes *!/*/}
                {/*                    {summary.students_missing_codes && summary.students_missing_codes.length > 0 && (*/}
                {/*                        <div>*/}
                {/*                            <h4 className="text-md font-medium text-gray-900 mb-3">*/}
                {/*                                SchülerInnen mit fehlenden Codes ({summary.students_missing_codes.length})*/}
                {/*                            </h4>*/}
                {/*                            <div className="max-h-96 overflow-y-auto space-y-2">*/}
                {/*                                {summary.students_missing_codes.map((student) => (*/}
                {/*                                    <div key={student.id} className="p-3 bg-gray-50 rounded-md">*/}
                {/*                                        <div className="text-sm">*/}
                {/*                                            <Link*/}
                {/*                                                to={`/school/students/${student.id}`}*/}
                {/*                                                className="font-medium text-imsblue-600 hover:text-imsblue-900"*/}
                {/*                                            >*/}
                {/*                                                {student.name} ({student.student_number})*/}
                {/*                                            </Link>*/}
                {/*                                            <span className="text-gray-600"> - </span>*/}
                {/*                                            <span className="text-xs text-gray-600">*/}
                {/*                                                {student.books.map((book, index) => (*/}
                {/*                                                    <span key={book.id}>*/}
                {/*                                                        {index > 0 && ', '}*/}
                {/*                                                        <Link*/}
                {/*                                                            to={`/books/${book.id}`}*/}
                {/*                                                            className="text-imsblue-600 hover:text-imsblue-900"*/}
                {/*                                                        >*/}
                {/*                                                            {book.title}*/}
                {/*                                                        </Link>*/}
                {/*                                                        {book.courses && book.courses.length > 0 && (*/}
                {/*                                                            <span className="ml-1">*/}
                {/*                                                                ({book.courses.map(c => c.course_number).join(', ')})*/}
                {/*                                                            </span>*/}
                {/*                                                        )}*/}
                {/*                                                    </span>*/}
                {/*                                                ))}*/}
                {/*                                            </span>*/}
                {/*                                        </div>*/}
                {/*                                    </div>*/}
                {/*                                ))}*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    )}*/}
                {/*                </div>*/}

                {/*                /!* No issues message *!/*/}
                {/*                {(!summary.missing_per_book || summary.missing_per_book.length === 0) &&*/}
                {/*                 (!summary.students_missing_codes || summary.students_missing_codes.length === 0) && (*/}
                {/*                    <div className="text-center py-4">*/}
                {/*                        <div className="text-green-600 font-medium">*/}
                {/*                            ✓ Alle Büchercodes sind korrekt zugewiesen*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                )}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*)}*/}

                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
